import { ValidationRules } from "aurelia-validation";

export class NewCarrierRequestSearchFormDto {
    entityType: string = "";
    legalName: string = undefined;
    dbaName: string = undefined;
    scacCode: string = undefined;
    dotNumber: string = undefined;
    mcNumber: string = undefined;
}

ValidationRules
    .ensure((m: NewCarrierRequestSearchFormDto) => m.entityType).required()
    .ensure((m: NewCarrierRequestSearchFormDto) => m.legalName).required()
    .ensure((m: NewCarrierRequestSearchFormDto) => m.mcNumber).satisfies((val, obj) => {
        if (obj.entityType == "TRUCKS" || obj.entityType == 'TRANSLOADER/TRUCKS') {
            if (obj.scacCode || obj.dotNumber || obj.mcNumber) {
                return true;
            }
            return false;
        }
        return true;
    })
    .ensure((m: NewCarrierRequestSearchFormDto) => m.scacCode).satisfies((val, obj) => {
        if (obj.entityType == "TRUCKS" || obj.entityType == 'TRANSLOADER/TRUCKS') {
            if (obj.scacCode || obj.dotNumber || obj.mcNumber) {
                return true;
            }
            return false;
        }
        return true;
    })
    .ensure((m: NewCarrierRequestSearchFormDto) => m.dotNumber).satisfies((val, obj) => {
        if (obj.entityType == "TRUCKS" || obj.entityType == 'TRANSLOADER/TRUCKS') {
            if (obj.scacCode || obj.dotNumber || obj.mcNumber) {
                return true;
            }
            return false;
        }
        return true;
    })
    .on(NewCarrierRequestSearchFormDto);





//export class NewCarrierRequestDto {
//    legalName: string = undefined;
//    dbaName: string = undefined;
//    scacCode: string = undefined;
//    dotNumber: string = undefined;
//    mcNumber: string = undefined;
//}

//ValidationRules
//    .ensure((m: NewCarrierRequestDto) => m.legalName).required()
//    .on(NewCarrierRequestDto);





export class NewCarrierRequestSubmitDto extends NewCarrierRequestSearchFormDto {
    // fields to submit request
    requestedForId: string = undefined;
    typeOfAuthority: string = undefined;
    contactName: string = undefined;
    contactEmail: string = undefined;
    contactPhone: string = undefined;
    // NOT used - be careful if adding these back, it will cause phantom FMCSA discrepancies errors on the details screen
    // legalAddressStreet: string = undefined;
    // legalAddressCity: string = undefined;
    // legalAddressState: string = undefined;
    // legalAddressZip: string = undefined;
    mainPhone: string = undefined;
    divisions = [];
    requiredInsurance: string = undefined;
    describeNeeds: string = undefined;
    dateNeeded: Date = undefined;
    isReevaluationRequest: Boolean = false;
    reevaluationRequestCarrierId: number = undefined;
    isInsuranceRenewalRequest: boolean = false;
    insuranceRenewalRequestCarrierId: number = undefined;
    isOnboardingRequest: Boolean = false;
    overrideFmcsaNotFound: boolean = false;

    constructor(defaultRequestedForId: string) {
        super();
        this.requestedForId = defaultRequestedForId;
    }
}

const isInFuture = (date) => new Date(date) >= new Date();

ValidationRules
    /// 10/27 #148902: Enhance Required fields when submitting new onboarding request
    // .ensure((m: NewCarrierRequestSubmitDto) => m.mainPhone).satisfies((val, obj) => (!obj.isReevaluationRequest) || !!val)
    // .ensure((m: NewCarrierRequestSubmitDto) => m.contactName).satisfies((val, obj) => (!obj.isReevaluationRequest) || !!val)
    // .ensure((m: NewCarrierRequestSubmitDto) => m.contactEmail).satisfies((val, obj) => (!obj.isReevaluationRequest) || !!val)
    .ensure((m: NewCarrierRequestSubmitDto) => m.dotNumber).satisfies((val, obj) => !obj.isOnboardingRequest || !!val)
    .ensure((m: NewCarrierRequestSubmitDto) => m.contactPhone).satisfies((val, obj) => !!val)
    .ensure((m: NewCarrierRequestSubmitDto) => m.contactName).satisfies((val, obj) => !!val)
    .ensure((m: NewCarrierRequestSubmitDto) => m.contactEmail).satisfies((val, obj) => !!val)
    .ensure((m: NewCarrierRequestSubmitDto) => m.divisions).satisfiesRule("arrayIsNotEmpty")
    .ensure((m: NewCarrierRequestSubmitDto) => m.requiredInsurance).required()
    .ensure((m: NewCarrierRequestSubmitDto) => m.describeNeeds).required()
    .ensure((m: NewCarrierRequestSubmitDto) => m.typeOfAuthority).required()
    .ensure((m: NewCarrierRequestSubmitDto) => m.dateNeeded).required().satisfiesRule("date").satisfies((val, obj) => isInFuture(val))
    .on(NewCarrierRequestSubmitDto);